import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { combo1, combo2, combo3, combo4 } from '../../assets/images/images';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1023, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
function OfferOverlay() {
  return (
    <div className='bg-greySecondary p-8 my-auto rounded-lg'>
      <div>
        <Carousel
          arrows={true}
          responsive={responsive}
          className='w-full h-full flex z-0'
        >
          {[combo1, combo2, combo3, combo4].map((el, id) => {
            return (
              <div
                key={id}
                className='m-4 rounded-xl overflow-hidden h-[15rem] object-cover'
              >
                <img src={el} alt='combo' className='block w-full' />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default OfferOverlay;
